export default (props = {}) => ({
	...props,
	textColor: props.fontColor,
	disclaimerAlts: props.angleImageInfos,
	trims: props.visualizerTabs?.map((tabs) => ({
		id: tabs.id,
		name: tabs.label,
		disclaimerAlts: tabs.angleImageInfos,
		views: tabs.visualizerInnerTabs?.map((innerTabs) => ({
			id: innerTabs.id,
			name: innerTabs.label,
			assetPathStructure: innerTabs.assetPathStructure,
			type: innerTabs.type,
			numAngles: innerTabs.numAngles,
			disclaimerAlts: innerTabs.angleImageInfos,
			modifiers: innerTabs?.modifiers?.map((modifier) => ({
				value: modifier.id,
				label: modifier.label,
				media: modifier.asset,
			})),
			swatches: innerTabs?.swatches?.map((swatch) => ({
				id: swatch?.id,
				name: swatch?.label,
				media: swatch?.asset,
				disclaimerAlts: swatch?.angleImageInfos,
			})),
		})),
		bespokeTrimFields:
			tabs.visualizerTabBespokeFields?.trimName &&
			tabs.visualizerTabBespokeFields?.basePrice
				? tabs.visualizerTabBespokeFields
				: undefined,
		categories: tabs.visualizerBespokeInnerTabs?.map((innerTabs) => ({
			id: innerTabs.id,
			name: innerTabs.label,
			type: innerTabs.type,
			numAngles: innerTabs.numAngles,
			currencySymbol: innerTabs.currencySymbol,
			assetPathStructure: innerTabs.assetPathStructure,
			assetExtension: innerTabs.assetExtension,
			disclaimerAlts: innerTabs.angleImageInfos,
			modifiers: innerTabs?.modifiers?.map((modifier) => ({
				value: modifier.id,
				label: modifier.label,
				media: modifier.asset,
				price: modifier.price,
				disclaimer: modifier.disclaimerCode,
				efcCode: modifier.efcCode,
			})),
			swatches: innerTabs?.swatches?.map((swatch) => ({
				id: swatch?.id,
				name: swatch?.label,
				media: swatch?.asset,
				disclaimerAlts: swatch?.angleImageInfos,
				price: swatch?.price,
				disclaimer: swatch?.disclaimerCode,
				efcCode: swatch?.efcCode,
				toolTipText: swatch?.toolTipText,
				toolTipImage: swatch?.toolTipImage,
			})),
		})),
	})),
});
